import React from 'react';
import '../styles/thingsdiff.css';
import thingsdiffImg from '../../../../assets/company/aboutus/philosophy.svg';

const ThingsDiff = () => {
    return (
        <section className="thingsdiff-section">
            <div className="thingsdiff-container">
                <div className="thingsdiff-content">
                    <h2 className="thingsdiff-title">
                        Our Philosophy
                    </h2>
                    <p className="thingsdiff-description">
                        At Synectiks, we believe technology should simplify operations, strengthen security, and deliver lasting value.
                        Every engagement is an opportunity to bring efficiency, resilience, and innovation to our customers. Once we solve a challenge, we systemize and automate the solution, so it consistently drives results with speed, reliability, and reduced risk.
                        Our focus is on creating practical, future-ready solutions that reduce complexity, maximize return on investment, and give enterprises confidence that their technology is always working for them.
                    </p>
                </div>
                <div className="thingsdiff-image">
                    <img
                        src={thingsdiffImg}
                        alt="We’ve always done things differently"
                        className="thingsdiff-img"
                    />
                </div>
            </div>
        </section>
    );
};

export default ThingsDiff;
